import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CadsSparklineBitComponent } from '../../bits/cads-sparkline-bit/cads-sparkline-bit.component';
import type { CadsSparklineBitConfig } from '../../bits/cads-sparkline-bit/cads-sparkline-bit.config';

import type { CadsSparklineSummaryConfig } from './cads-sparkline-summary.config';

/**
 * **Sparkline summary:** **leadingRows** beside an 80×40 (by default) {@link CadsSparklineBitComponent}, plus **summaryRow**
 * (accent value). No surface of its own—place inside {@link CadsCardViewComponent}. Optional divider above **summaryRow**
 * when there is at least one leading row.
 */
@Component({
    selector: 'cads-sparkline-summary',
    imports: [CadsSparklineBitComponent],
    templateUrl: './cads-sparkline-summary.component.html',
    styleUrl: './cads-sparkline-summary.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CadsSparklineSummaryComponent {
  readonly config = input.required<CadsSparklineSummaryConfig>();

  /** Divider only when there are leading rows and **showDivider** is not `false`. */
  protected readonly _showDivider = computed(() => {
    if (this.config().leadingRows.length === 0) {
      return false;
    }
    return this.config().showDivider !== false;
  });

  protected readonly _sparklineConfig = computed((): CadsSparklineBitConfig => {
    const s = this.config().sparkline;
    return {
      ...s,
      width: s.width ?? 80,
      height: s.height ?? 40,
    };
  });

  /** CSS `color` value matching the nested sparkline stroke token. */
  protected readonly _accentColorVar = computed(() => {
    const key = this.config().sparkline.color ?? 'mid-gray';
    return `var(--cads-color-${key})`;
  });
}
